import { render, staticRenderFns } from "./InquiryGroupTabsView.vue?vue&type=template&id=9e356524&"
import script from "./InquiryGroupTabsView.vue?vue&type=script&lang=js&"
export * from "./InquiryGroupTabsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports